module.exports = __webpack_public_path__ + "media/images/emoticons/three-5cf814c64fb6ec5ee3e9b99613e53489.gif";